let vid = document.getElementById("featured_video"); 
function playVid() { vid.play(); } 
function pauseVid() { vid.pause(); }
 
$( document ).ready(function() {      
    $(".plays_btn").click(function() {  
        $(this).removeClass("active");
        $(".pause_btn").addClass("active");  
    });   

    $(".pause_btn").click(function() { 
        $(this).removeClass("active");  
        $(".plays_btn").addClass("active");  
    });   
});

// const EL_video = document.querySelector("#featured_video");
// const EL_play = document.querySelector(".thumb_video");

// EL_play.addEventListener("click", () => {
//   const isPaused = EL_video.paused;
//   EL_video[isPaused ? "play" : "pause"]();
//   EL_video.classList.toggle("v-none", !isPaused);
// });

jQuery(".faq_box  h5").click(function(){if(jQuery(this).hasClass("show"))
{jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
else
{jQuery(".faq_box h5").removeClass("show");jQuery(".faq_box h5").next().slideUp();jQuery(this).addClass("show");jQuery(this).next().slideDown();}});

$('.review_list').slick({
  infinite: true,
  arrows:true,
  slidesToShow: 1,
  slidesToScroll: 1
});

$('.menu_btn').on('click', function () {
    $('.menu-subs').addClass('open');
});

$( '.menu_close' ).on("click", function(){
  $('.menu-subs').removeClass('open');
});





